import React from "react";

const HighlightableText = ({active, children, className}) => <span
    className={`highlightable-text ${active ? 'highlightable-text--active' : null} ${className}`}>
    {children}
</span>;

export default HighlightableText;